<div class="app-footer-container" [ngClass]="{ 'app-footer-container-default': (hasButtons$ | async) === false }" fxLayout="row" fxLayout="stretch stretch">
  <xpo-utils-version-banner></xpo-utils-version-banner>
  <div fxLayout="row" fxLayoutAlign="space-between center" class="app-footer-container-row">
    <div fxLayout="row" fxLayoutAlign="start center" class="app-footer-container-row-left">
      <button
        *ngFor="let button of footerService.leftButtonConfig$ | async; let i = index"
        id="left-footer-{{ i + 1 }}-button"
        mat-button
        [ngClass]="{ 'mat-raised-button': button.raised }"
        [color]="button.color"
        [disabled]="button.disabled"
        [ngStyle]="{ display: button.visible ? 'block' : 'none' }"
        (click)="buttonClicked(button.label)"
      >
        {{ button.label }}
      </button>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" class="app-footer-container-row-right">
      <button
        *ngFor="let button of footerService.rightButtonConfig$ | async; let i = index"
        id="right-footer-{{ i + 1 }}-button"
        mat-button
        [ngClass]="{ 'mat-raised-button': button.raised }"
        [color]="button.color"
        [disabled]="button.disabled$ ? (button.disabled$ | async) : button.disabled"
        [ngStyle]="{ display: button.visible ? 'block' : 'none' }"
        (click)="buttonClicked(button.label)"
      >
        {{ button.label }}
      </button>
    </div>
  </div>
</div>
